import {z} from 'zod'
import i18n from '@/translations/i18n'

export const BudgetFormSchema = z.object({
    year: z.number().int(),
    outpatientAmount: z.string().min(1),
    houseAmount: z.string().min(1)
})
export type BudgetFormSchema = z.infer<typeof BudgetFormSchema>

export const ExternalCostFormSchema = z
    .object({
        description: z.string().min(1, {message: i18n.t('errors:required')}),
        amount: z.string().min(1, {message: i18n.t('errors:required')}),
        type: z.enum(['yearly', 'monthly'], {required_error: i18n.t('errors:required')}),
        period: z.string().min(1, {message: i18n.t('errors:required')}),
        isRecurring: z.boolean().default(false),
        until: z.string().optional()
    })
    .superRefine((data, ctx) => {
        if (data.isRecurring && !data.until) {
            ctx.addIssue({code: z.ZodIssueCode.custom, message: i18n.t('errors:required'), path: ['until']})
        }
    })

export type ExternalCostFormSchema = z.infer<typeof ExternalCostFormSchema>

export const AccessRateFormSchema = z.object({
    rate: z.string({required_error: i18n.t('errors:required')}).min(1, {message: i18n.t('errors:required')}),
    newStart: z.string({required_error: i18n.t('errors:required')}).min(1, {message: i18n.t('errors:required')}),
    previousEnd: z.string({required_error: i18n.t('errors:required')}).min(1, {message: i18n.t('errors:required')})
})
export type AccessRateFormSchema = z.infer<typeof AccessRateFormSchema>
